import { BaseConfig, Nullable } from '.'

export type Plain = 'object'

export interface GenericObject {
  id: string
  [x: string]: any
}

export type Config = BaseConfig & {
  type: 'object'
} & (
    | {
        nullable?: true
        defaultValue?: GenericObject
      }
    | {
        nullable: false
        defaultValue: GenericObject
      }
  )

export type PlainResult = GenericObject | null
export type Result<T extends Config> = Nullable<T, T['array'] extends true ? GenericObject[] : GenericObject>

const transformValue = (value: any, config?: Config): GenericObject | null => {
  const nullable = config?.nullable ?? true
  const defaultValue = nullable ? config?.defaultValue ?? null : (config?.defaultValue as GenericObject)

  if (typeof value !== 'object' || Array.isArray(value)) {
    return defaultValue
  }

  return value as GenericObject
}

export const transform = (value: any, config?: Config | Plain): GenericObject | GenericObject[] | null => {
  if (config === 'object') {
    return transformValue(value)
  }

  const array = config?.array ?? false

  if (array) {
    if (!Array.isArray(value)) {
      return []
    }

    return value.map((item) => transformValue(item, config)).filter(Boolean) as GenericObject[]
  }

  return transformValue(value, config)
}
